import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { useDisconnectFireflies } from "../../api/generated/generated";

interface DisconnectConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export function DisconnectConfirmDialog({
  open,
  onClose,
  onSuccess,
}: DisconnectConfirmDialogProps) {
  const disconnectMutation = useDisconnectFireflies();

  const handleConfirm = async () => {
    try {
      await disconnectMutation.mutateAsync();
      onSuccess();
    } catch {
      // Error is handled by the mutation
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Disconnect Fireflies</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Are you sure you want to disconnect your Fireflies account? Your
          imported transcripts will be preserved, but you won't be able to
          import new ones until you reconnect.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={disconnectMutation.isPending}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={disconnectMutation.isPending}
        >
          {disconnectMutation.isPending ? "Disconnecting..." : "Disconnect"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
